import { Timestamp } from 'firebase/firestore';

import { TNullableString } from './base';
import { IEventAtRead, IEventAtWrite } from './event';

export type TMainContactDetails = {
  name: string;
  email: string;
  phoneNumber: string;
};

export enum EPlanType {
  ADVISORY = 'advisory',
  VALUE_ADD = 'value-add',
  AFFILIATE = 'affiliate'
}

export type TPlanDetails = {
  type: EPlanType;
  advisorSeats: number;
  profileSeats: number;
};

export enum EOrganisationStatus {
  PREP = 'prep',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  DISABLED = 'disabled'
}

export interface IOrganisationWrite {
  name: string;
  // Stable URL-safe identifier derived from `name` on create, locked after
  // first activation. Drives `public_organisations/{slug}` mirror and
  // `gs://lifedocs-public/organisations/{slug}-logo.png` logo path.
  slug?: string;
  // Set on first PREP → ACTIVE transition; used by on-org-updated to
  // distinguish first-activation side effects from reactivation.
  activatedAt?: Timestamp | null;
  logoURL: TNullableString;
  websiteURL: TNullableString;
  physicalAddress: TNullableString;
  registrationNumber: TNullableString;
  vatNumber: TNullableString;
  organisationType: string;
  billingAddress: TNullableString;
  mainContact: TMainContactDetails | null;
  plan: TPlanDetails | null;
  status: EOrganisationStatus;
  advisorSeatsUsed: number;
  profileSeatsUsed: number;
  averageERS: number;
  created: IEventAtWrite;
  updated: IEventAtWrite;
}

export interface IOrganisationRead extends IOrganisationWrite {
  id: string;
  created: IEventAtRead;
  updated: IEventAtRead;
}

export interface IPublicOrganisationWrite {
  name: string;
  orgId: string;
  logoURL: string;
  status?: EOrganisationStatus;
  created: IEventAtWrite;
  updated: IEventAtWrite;
}

export interface IPublicOrganisationRead extends IPublicOrganisationWrite {
  id: string;
  created: IEventAtRead;
  updated: IEventAtRead;
}
